import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { Card } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { ReactComponent as Delete } from "assets/img/svg/Delete.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";

import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { setMasterDropdowns } from "../../../../../redux/globalData/globalDataAction";
import AAutoComplete from "../../common/form-fields-mui/AAutoComplete";
import { EyeIcon } from "../../unAssigned/studentCharges/common";
import AInput from "../../common/formFeilds/customInput/AInput";
import AButton from "../../common/form-fields-mui/AButton";
import { endpoint } from "../../common/constant";
import APopover from "../../common/a-popover";

import NoBranchOverlay from "./NoBranchOverlay";
import { UserDetails } from "appContext";
import "./styles.scss";

const getDateFormateDate = (date) => {
  if (moment(date).isValid()) {
    return new moment(date).format("DD/MM/YYYY");
  }
  return "-";
};

const AdditionalBranches = ({
  setIsAdditionalBranchEditing,
  editMode = true,
  additionalBranches = [],
  setAdditionalBranches,
}) => {
  // const MAX_BRANCH_ALLOWED = 5;
  const dispatch = useDispatch();
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );
  const userDetails = useContext(UserDetails);

  const [editingRow, setEditingRow] = useState({
    isEditing: false,
    rowIndex: 0,
  });

  const [businessAreaOptions, setBusinessAreaOptions] = useState([]);
  const [roomsDropdown, setRoomsDropdown] = useState([]);
  const [userIdError, setUserIdError] = useState({
    isError: false,
    msg: "",
    rowIndex: 0,
  });

  useEffect(() => {
    // reset if junk data
    if (additionalBranches.length && !additionalBranches[0].coordinatorName)
      setAdditionalBranches([]);
  }, []);

  useEffect(() => {
    if (masterDropdowns?.businessArea[0]?.businessAreaDesc) {
      const businessAreaOptions = masterDropdowns?.businessArea.map((bu) => ({
        label: bu.label,
        value: bu.businessAreaId,
        businessAreaDesc: bu.businessAreaDesc,
        businessAreaId: bu.businessAreaId,
      }));

      setBusinessAreaOptions(businessAreaOptions);
    } else {
      fetchBUDropdown();
    }
  }, [masterDropdowns.businessArea]);

  useEffect(() => {
    const getRooms = async () => {
      const buId = editingRow.businessArea?.businessAreaId;
      const url = `${endpoint.room.getAllActiveRoomByBusinessArea}/${buId}`;
      const response = await fetchAllPromisedData(url);

      if (response?.length) {
        const roomsOptions = response.map(({ id, roomCode, roomName }) => ({
          label: roomName,
          value: id,
          roomCode,
        }));
        setRoomsDropdown(roomsOptions);
      } else setRoomsDropdown([]); //reset no rooms for current BU
    };

    if (editingRow?.businessArea?.value) getRooms();
  }, [editingRow.businessArea]);

  const fetchBUDropdown = async () => {
    const buResponse = await getBusinessAreasDropdown();

    dispatch(
      setMasterDropdowns({
        businessArea: buResponse.map((item) => ({
          label: `${item.businessAreaDispValue}`,
          value: item.businessAreaDispValue,
          businessAreaId: item.id,
          businessAreaDesc: item.businessAreaDesc,
          regionId: item.regionId || "",
          gstInNumber: item.gstInNumber || "",
        })),
      })
    );
  };

  const getBusinessAreasDropdown = async () => {
    const res = await fetchAllPromisedData(
      `${endpoint?.businessArea.getAllActiveV2}`
    );

    if (res.length) {
      return res;
    }

    return [];
  };

  const addNewBranch = () => {
    // remove selected BU for further selection
    const selectedBuList = additionalBranches.map(
      (branch) => branch.businessArea.value
    );
    const updatedBuOptions = businessAreaOptions.filter(
      (option) => !selectedBuList.includes(option.value)
    );
    setBusinessAreaOptions(updatedBuOptions);

    const branch = {
      isNew: true,
      businessArea: "",
      room: "",
      coordinator: "",
      coordinatorName: "",
    };

    setEditingRow({ isEditing: true, rowIndex: additionalBranches.length });
    setAdditionalBranches([...additionalBranches, branch]);
    setIsAdditionalBranchEditing(true);
  };

  const isEligibleCoordinator = (userDetails) => {
    const isCoordinator = userDetails.role.includes("Coordinator");

    const userBU = userDetails.facultyMasterBusinessAreasResponseList.map(
      (bu) => bu.businessAreaKey
    );
    const isUserAvailableOnSelectedBU = userBU.includes(
      editingRow.businessArea.value
    );

    return isCoordinator && isUserAvailableOnSelectedBU;
  };

  const handleEditClick = (rowIndex) => {
    const { businessArea, room, coordinator, coordinatorName } =
      additionalBranches[rowIndex];

    setEditingRow({
      isEditing: true,
      rowIndex,
      businessArea,
      room,
      coordinator,
      coordinatorName,
    });
    setIsAdditionalBranchEditing(true);
  };

  const handleSaveClick = async () => {
    if (!checkUniqueCoordinator()) return;

    const empIdResponse = await fetchAllPromisedData(
      `${
        endpoint.faculty.getAllFacultyMasterKeys
      }/${editingRow.coordinator.trim()}`,
      true,
      false
    );

    const userFound = empIdResponse?.data?.facultyMasterListDTO || [];

    if (userFound.length && isEligibleCoordinator(userFound[0])) {
      const { rowIndex, businessArea, room } = editingRow;

      // call verifyId API -> if ok turn editing off and update `additionalBranches` array with coordinatorName
      const branch = {
        isNew: false,
        businessArea,
        room,
        coordinator: userFound[0].facultyId,
        coordinatorName: userFound[0].facultyName,
        ...(additionalBranches[rowIndex]?.createdBy
          ? {
              id: additionalBranches[rowIndex].id,
              createdBy: additionalBranches[rowIndex].createdBy,
              createdOn: additionalBranches[rowIndex].createdOn,
              updatedBy: userDetails.employeeId,
              updatedOn: new Date().toISOString(),
            }
          : {
              createdBy: userDetails.employeeId,
              createdOn: new Date().toISOString(),
              updatedBy: userDetails.employeeId,
              updatedOn: new Date().toISOString(),
            }),
      };

      setAdditionalBranches(
        additionalBranches.map((item, index) =>
          index === rowIndex ? branch : item
        )
      );
      setUserIdError({
        isError: false,
        msg: "",
        rowIndex: 0,
      });
      turnOffEditing();
      //  else error for correct empId
    } else if (userFound.length && !isEligibleCoordinator(userFound[0])) {
      setUserIdError({
        isError: true,
        msg: "Enter a valid coordinator of this branch to proceed.",
        rowIndex: editingRow.rowIndex,
      });
    } else
      setUserIdError({
        isError: true,
        msg: empIdResponse.data?.message || "Faculty Id not found",
        rowIndex: editingRow.rowIndex,
      });
  };

  const handleCancelClick = (index) => {
    if (additionalBranches[index].isNew) handleDeleteRow(index);

    turnOffEditing();
  };

  const turnOffEditing = () => {
    //  turn off editing
    setEditingRow({ isEditing: false, rowIndex: 0 });
    setIsAdditionalBranchEditing(false);
    setUserIdError({
      isError: false,
      msg: "",
      rowIndex: 0,
    });
  };

  const handleDeleteRow = (rowIndex) => {
    let rowsAfterDeletion = [];
    if (additionalBranches[rowIndex]?.isDeleted === false) {
      rowsAfterDeletion = additionalBranches.map((obj, index) =>
        index === rowIndex ? { ...obj, isDeleted: true } : obj
      );
    } else
      rowsAfterDeletion = additionalBranches.filter(
        (_, index) => index !== rowIndex
      );

    setAdditionalBranches(rowsAfterDeletion);
  };

  function checkUniqueCoordinator() {
    const { rowIndex, coordinator } = editingRow;

    const isCoordinatorPresent = additionalBranches.findIndex(
      (branch) =>
        branch.coordinator.toUpperCase() == coordinator.toUpperCase().trim()
    );

    if (![rowIndex, -1].includes(isCoordinatorPresent)) {
      setUserIdError({
        isError: true,
        msg: "Eligible coordinator not available.",
        // Either create a new coordinator for this BU or remove the mapping of existing coordinator for this BU
        rowIndex,
      });
      return false;
    }

    return true;
  }

  const rowFormHandler = (value, key) => {
    setEditingRow((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "coordinator" && { coordinatorName: "" }),
      ...(key === "businessArea" && {
        room: "",
        coordinator: "",
        coordinatorName: "",
      }),
    }));

    if (["coordinator", "businessArea"].includes(key))
      setUserIdError({
        isError: false,
        msg: "",
        rowIndex: 0,
      });
  };

  return (
    <div className="w-100">
      <div className="d-flex align-items-center justify-content-between">
        <span className="text-bold color-dark">Additional Branches</span>
        {editMode && (
          <AButton
            size="xs"
            variant="primary_filled"
            disabled={editingRow.isEditing}
            onClick={() => addNewBranch()}
          >
            + Additional Branch
          </AButton>
        )}
      </div>

      <div className="tableHeader">
        <div>Business Area</div>
        <div>Room</div>
        <div>Coordinators</div>
        <div>Created on/by</div>
        <div>Updated on/by</div>

        {editMode && <div>Action</div>}
      </div>

      {additionalBranches.length ? (
        additionalBranches.map(
          (
            { businessArea, room, coordinator, coordinatorName, ...props },
            index
          ) => {
            if (props?.isDeleted) return <></>;
            return (
              <div className="tableRow" key={coordinator}>
                {editingRow.isEditing && index === editingRow.rowIndex ? (
                  <>
                    <AAutoComplete
                      currentValue={editingRow.businessArea}
                      handleChange={(value) => {
                        rowFormHandler(value, "businessArea");
                      }}
                      items={businessAreaOptions}
                      isMulti={false}
                      placeholder={"Select"}
                    />

                    <AAutoComplete
                      currentValue={editingRow?.room}
                      handleChange={(value) => {
                        rowFormHandler(value, "room");
                      }}
                      items={roomsDropdown}
                      isMulti={false}
                      placeholder={"Select"}
                      isDisabled={!editingRow.businessArea}
                    />

                    <div className="d-flex flex-column">
                      <AInput
                        value={editingRow?.coordinator}
                        handler={(val) => rowFormHandler(val, "coordinator")}
                        placeholder={"Enter Faculty Id"}
                        maxLength={100}
                        disabled={!editingRow.businessArea}
                      />
                      {userIdError.isError &&
                        userIdError.rowIndex === index && (
                          <small className="text-danger font-sm">
                            {userIdError.msg}
                          </small>
                        )}
                    </div>
                    <div>
                      {props?.createdOn
                        ? getDateFormateDate(props?.createdOn)
                        : "-"}
                      {props?.createdOn && (
                        <Popover on={props?.createdOn} by={props?.createdBy} />
                      )}
                    </div>
                    <div>
                      {props?.updatedOn
                        ? getDateFormateDate(props?.updatedOn)
                        : "-"}
                      {props?.updatedOn && (
                        <Popover on={props?.updatedOn} by={props?.updatedBy} />
                      )}
                    </div>

                    <div>
                      <AButton
                        variant="primary_filled"
                        size="xs"
                        onClick={handleSaveClick}
                        disabled={
                          !editingRow.businessArea ||
                          !editingRow.room ||
                          !editingRow.coordinator
                        }
                      >
                        Save
                      </AButton>

                      <CloseIcon
                        className="ml-2 cursor"
                        onClick={() => handleCancelClick(index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      {businessArea.label}
                      {/* {businessArea?.businessAreaDesc} */}
                    </div>
                    <div>{room.label}</div>
                    <div>
                      {coordinator} {coordinatorName}
                    </div>

                    <div>
                      {props?.createdOn
                        ? getDateFormateDate(props?.createdOn)
                        : "-"}
                      {props?.createdOn && (
                        <Popover on={props?.createdOn} by={props?.createdBy} />
                      )}
                    </div>

                    <div>
                      {props?.updatedOn
                        ? getDateFormateDate(props?.updatedOn)
                        : "-"}
                      {props?.updatedOn && (
                        <Popover on={props?.updatedOn} by={props?.updatedBy} />
                      )}
                    </div>

                    {editMode && (
                      <div>
                        <IconButtonWrapper
                          onClick={() => handleEditClick(index)}
                          disabled={editingRow.isEditing}
                        >
                          <EditIcon />
                        </IconButtonWrapper>
                        <IconButtonWrapper
                          onClick={() => handleDeleteRow(index)}
                          disabled={editingRow.isEditing}
                        >
                          <Delete />
                        </IconButtonWrapper>
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          }
        )
      ) : (
        <NoBranchOverlay editMode={editMode} />
      )}
    </div>
  );
};

export default AdditionalBranches;

const Popover = ({ by, on }) => {
  const getFormattedTime = (date) => {
    if (moment(date).isValid()) {
      return new moment(date).format("hh:mm A");
    }
    return "12:00 AM";
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
          }}
          className="cursor-pointer ml-1"
        >
          <EyeIcon />
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 p-2 regular-body label-color"
            style={{ borderRadius: "12px" }}
          >
            {getDateFormateDate(on)} at {getFormattedTime(on)} by {by}
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};
